import React, { FC, ReactNode } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import RestoreIcon from '@mui/icons-material/Restore';
import { Drawer, Typography, useMediaQuery, useTheme } from '@mui/material';
import {
  Header,
  HistoryButton,
  MenuButton,
  MobileDrawer,
} from 'src/components/Drawer/styled';

interface ResponsiveDrawerProps {
  mobileOpen: boolean;
  collapsed?: boolean;
  children: ReactNode;
  onClose: () => void;
  onMenuClick: () => void;
}

export const ResponsiveDrawer: FC<ResponsiveDrawerProps> = ({
  mobileOpen,
  collapsed = false,
  children,
  onClose,
  onMenuClick,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return isSmallScreen ? (
    <>
      <Header>
        <MenuButton
          onClick={onMenuClick}
          color="secondary"
          active={+mobileOpen}
          size="large"
        >
          <MenuIcon />
        </MenuButton>
        <Typography variant="h2" component="p">
          Kipify
        </Typography>
        <HistoryButton color="secondary" size="large">
          <RestoreIcon />
        </HistoryButton>
      </Header>
      <MobileDrawer
        anchor="top"
        open={mobileOpen}
        onClose={onClose}
        ModalProps={{
          keepMounted: true,
        }}
      >
        {children}
      </MobileDrawer>
    </>
  ) : (
    <Drawer
      variant="permanent"
      open
      PaperProps={{
        sx: {
          zIndex: 1300,
          width: collapsed ? 72 : 240,
          top: 'var(--kipify-topbar-height, 0px)',
          height: 'calc(100vh - var(--kipify-topbar-height, 0px))',
          transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          overflow: 'hidden',
        },
      }}
    >
      {children}
    </Drawer>
  );
};
